<template lang="pug">
.biz-cell(@click="toBiz()", role="button", v-if="biz")
  ImgBlock(:biz="biz")
  InfoBlock(:biz="biz")
</template>

<script>
import ImgBlock from "./ImgBlock";
import InfoBlock from "./InfoBlock";

export default {
  name: "BizCell",
  components: { ImgBlock, InfoBlock },
  props: ["biz"],
  methods: {
    toBiz() {
      this.$router.push("/bizs/" + this.biz.url);
    },
  },
};
</script>

<style lang="sass" scoped>
.biz-cell
  overflow: hidden
</style>
